import React from 'react';
import PageHeader from '../../../components/PageHeader';

export const UnsubscribedPaymentHeader = () => {
	return (
		<PageHeader header="Billing" />
	);
};
